<template>
  <div id="crm-feedback-page">
    <div class="crm-header-container">
        <el-row></el-row>
        <el-row>
            <i v-if="showIconClose" class="el-icon-close" @click="close"></i>
            <div class="crm-body-container">
                <img :src="`${this.crm_public_path}${restaurantInfo.logoImgKey}`" class="brand-header">
                <span class="header-text"> {{ $t("customer-feedback.header-experience") }}</span>
                <img src="../../assets/img/customer-feedback.png" class="img-customer">
                <el-rate v-model="feedbackFrom.rating" @change="changeRating"></el-rate>
                <div  v-if="feedbackFrom.rating > 3 || feedbackFrom.rating == 0 " class="flex-colomn-center">
                  <span class="text-head-bubble">{{ $t("customer-feedback.header-bubble-1") }}</span>
                  <div class="area-bubbles">
                    <div class="feedback-bubble" @click="clickBubble(1)" :class="{'feedback-bubble-active' : bubbelActive[0] == 1}">{{ $t("customer-feedback.buble-1-1") }}</div>
                    <div class="feedback-bubble" @click="clickBubble(2)" :class="{'feedback-bubble-active' : bubbelActive[1] == 1}">{{ $t("customer-feedback.buble-1-2") }}</div>
                    <div class="feedback-bubble" @click="clickBubble(3)" :class="{'feedback-bubble-active' : bubbelActive[2] == 1}">{{ $t("customer-feedback.buble-1-3") }}</div>
                    <div class="feedback-bubble" @click="clickBubble(4)" :class="{'feedback-bubble-active' : bubbelActive[3] == 1}">{{ $t("customer-feedback.buble-1-4") }}</div>
                    <div class="feedback-bubble" @click="clickBubble(5)" :class="{'feedback-bubble-active' : bubbelActive[4] == 1}">{{ $t("customer-feedback.buble-1-5") }}</div>
                  </div>
                </div>
                <div v-else-if="feedbackFrom.rating <= 3" class="flex-colomn-center">
                  <span class="text-head-bubble">{{ $t("customer-feedback.header-bubble-2") }}</span>
                  <div class="area-bubbles">
                    <div class="feedback-bubble" @click="clickBubble(6)" :class="{'feedback-bubble-active' : bubbelActive[5] == 1}">{{ $t("customer-feedback.buble-2-1") }}</div>
                    <div class="feedback-bubble" @click="clickBubble(7)" :class="{'feedback-bubble-active' : bubbelActive[6] == 1}">{{ $t("customer-feedback.buble-2-2") }}</div>
                    <div class="feedback-bubble" @click="clickBubble(8)" :class="{'feedback-bubble-active' : bubbelActive[7] == 1}">{{ $t("customer-feedback.buble-2-3") }}</div>
                    <div class="feedback-bubble" @click="clickBubble(9)" :class="{'feedback-bubble-active' : bubbelActive[8] == 1}">{{ $t("customer-feedback.buble-2-4") }}</div>
                    <div class="feedback-bubble" @click="clickBubble(10)" :class="{'feedback-bubble-active' : bubbelActive[9] == 1}">{{ $t("customer-feedback.buble-2-5") }}</div>
                  </div>
                </div>
                <el-input type="textarea" :rows="2" :placeholder=" $t('customer-feedback.header-bubble-1')" v-model="feedbackFrom.comment" maxlength="500" show-word-limit @focus="trackFeedback(5, 'CRMFeedback');"> </el-input>
                <el-button class="crm-submit" :class="{'disable-btn-crm' : disableButton }" :disabled="disableButton" @click="createFeedback">{{ $t("customer-feedback.send") }}</el-button>
            </div>
        </el-row>
    </div>
  </div>
</template>

<script>
import "@/styles/customer-feedback.css";
import { mapActions, mapGetters, mapMutations } from "vuex";
import GATracking from "@/helper/GATrackingMixins";
export default {
  mixins: [GATracking],
  data() {
    return {
      crm_public_path: process.env.VUE_APP_S3_PUBLIC_PATH,
      title: this.$t('coupon.coupon-mine'),
      feedbackFrom : {
        rating : null,
        bubbel :[],
        comment :'',
      },
      oldRateing:0,
      bubbelActive : [0,0,0,0,0,0,0,0,0,0],
    };
  },
  mounted() {
    this.viewFeedback()
  },
  computed: {
    ...mapGetters({
      showIconClose: 'feedback/iconClose',
      restaurantUUID: 'restaurant/restaurantUUID',
      branchUUID: 'branch/branchUUID',
      restaurantInfo: 'restaurant/restaurantInfo'
    }),
    disableButton(){
      if(this.feedbackFrom.rating == null || this.feedbackFrom.rating == 0) return true
      else return false
    }
  },
  methods: {
    ...mapActions({
      createCustomerFeedback: "feedback/createCustomerFeedback",
    }),
    ...mapMutations({
      setFeedbackType: "feedback/SET_FEEDBACK_TYPE",
      setComment: "feedback/SET_COMMENT",
      setRating: "feedback/SET_RATING",
    }),
    changeRating(){
      this.trackFeedback(3, 'CRMFeedback');
      if( ( this.oldRateing > 3 && this.feedbackFrom.rating <= 3 ) || ( this.oldRateing <= 3 && this.feedbackFrom.rating > 3) ) {
        this.bubbelActive = [0,0,0,0,0,0,0,0,0,0]
        this.feedbackFrom.bubbel = []
      }
    },
    clickBubble(id){
      this.oldRateing = this.feedbackFrom.rating
      if( this.feedbackFrom.bubbel.includes(id)){
          //ลบbuble ออกจาก from ลบ active
          let index = this.feedbackFrom.bubbel.indexOf(id);
          if (index !== -1) {
              this.feedbackFrom.bubbel.splice(index, 1);
              this.bubbelActive[id-1] = 0
          }
      }
      else{
        this.trackFeedback(4, 'CRMFeedback');
          //เพิ่ม buble ลง from เพิ่ม active
          this.feedbackFrom.bubbel.push(id)
          this.bubbelActive[id-1] = 1
      }
      this.$forceUpdate(); 
    },
    async createFeedback(){
      this.trackFeedback(6, 'CRMFeedback');
      this.setFeedbackType( this.feedbackFrom.bubbel )
      this.setComment( this.feedbackFrom.comment )
      this.setRating( this.feedbackFrom.rating )

      this.createCustomerFeedback()
    },
    close(){
        this.$router.push({
          path: `/${this.restaurantUUID}/${this.branchUUID}`
        })
    }
  }
};
</script>

